// npm packages
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";

// assets
import { StarFill } from "react-bootstrap-icons";

// config
import { testimonials } from "../config/testimonials";

import "./CustomCarousel.css";

export const CustomCarousel = () => {
  const { t } = useTranslation();

  return (
    <Carousel
      touch={true}
      interval={null}
      className="mt-3 owl-carousel owl-theme skill-slider"
    >
      {testimonials.map(({ name, image, company, commentKey }, index) => (
        <Carousel.Item key={index}>
          <div className="testimonial-card">
            <div className="testimonial-card__header">
              <img className="testimonial-card__image" src={image} alt={index}/>
              <div className="testimonial-card__user-descr-container">
                <p className="testimonial-card__user-name">{name}.</p>
                <p className="testimonial-card__user-company">{company}.</p>
                <div className="testimonial-card__score-container">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <div className="testimonial-card__star-container" key={item}>
                      <StarFill  size="1rem" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <p className="testimonial-card__comment">{t(commentKey)}</p>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
